<template>

    <b-container fluid class="p-0 m-0" id="home">
        <Banner />
        <About />
        <Specialty />
        <Services />
        <Contacts />
        <Partners />
    </b-container>

</template>

<script>
import About from '@/components/sections/About.vue';
import Banner from '@/components/sections/Banner.vue';
import Contacts from '@/components/sections/Contacts.vue';
import Partners from '@/components/sections/Partners.vue';
import Services from '@/components/sections/Services.vue';
import Specialty from '@/components/sections/Specialty.vue';

    export default {
        name: 'teste',
        components: {Banner, About, Specialty, Services, Contacts, Partners}
    }
</script>

<style scoped lang="scss">
</style>